import { useSelector } from 'react-redux'

import { Roles } from 'clickNgo/configs/roles'
import { selectUser } from 'core-components/sitebuilder/store/selectors/selectUser'

export const useCheckLegalApproverAccess = () => {
  const { roleIds } = useSelector(selectUser)

  return roleIds.includes(Roles.LEGAL_APPROVER)
}
